<!-- @format -->

<pager>
  <div class="pagination">
    <ul>
      <a
        onclick="{ e=>props.onPager(e, props.pager.prev) }"
        disabled="{ props.pager.prev == props.pager.page }"
      >
        <span>&lt;</span>
      </a>
      <a
        each="{ page in getPages() }"
        class="{ page == props.pager.page ? 'is-active' : '' }"
        onclick="{ e=>props.onPager(e, page) }"
        disabled="{ page == props.pager.page }"
      >
        <span>{ page }</span>
      </a>
      <a
        onclick="{ e=>props.onPager(e, props.pager.next) }"
        disabled="{ props.pager.next == props.pager.page }"
      >
        <span>&gt;</span>
      </a>
    </ul>
  </div>

  <script>
    export default {
      getPages() {
        let pages = Number(
          this.props.pager.last < this.props.maxPages
            ? this.props.pager.last
            : this.props.maxPages
        );
        let bias = this.props.pager.page - Math.ceil(this.props.maxPages / 2);
        bias = bias < 0 ? 0 : bias;
        bias =
          bias + pages > this.props.pager.last
            ? this.props.pager.last - pages
            : bias;

        return Array.from({ length: pages }, (v, i) => bias + i + 1);
      },
    };
  </script>
</pager>
